module.exports = __webpack_public_path__ + "img/skating004.d6178021.jpg";